exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DropListItem__checkbox,\n.DS__DropListItem__icon-position {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__DropListItem__checkbox {\n  display: inline-block;\n  margin-right: 12px;\n}\n\n.DS__DropListItem__icon-position {\n  margin-right: auto;\n}\n", ""]);

// exports
exports.locals = {
	"checkbox": "DS__DropListItem__checkbox",
	"icon-position": "DS__DropListItem__icon-position"
};